export default __webpack_public_path__ + "ae2a9244ad482382a58dba54803b0012.png";